export default __webpack_public_path__ + "static/media/Neutral.00ead19d.svg";